import {Alert, Box, CircularProgress} from "@mui/material";
import {Navigate, useLocation, useSearchParams} from "react-router-dom";
import {useSessionQuery} from "../app/api/api";
import {useTranslation} from "react-i18next";
import {PermissionLevel} from "../app/api/model/user";

export interface RequireAuthProps {
    children?: JSX.Element;
    permissionLevel?: PermissionLevel;
}

function RequireAuth({children, permissionLevel = PermissionLevel.VIEW_ONLY}: RequireAuthProps) {
    const {t} = useTranslation();
    const {data: session, isError} = useSessionQuery();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    // If not logged in, redirect to login screen.
    if (isError) {
        return <Navigate to="/login" state={{from: `${location.pathname}?${searchParams}`}} replace />;
    }

    if (session) {
        if (session.permissionLevel >= permissionLevel) {
            // If logged in and permissionLevel is sufficient, show children.
            return children || null;
        } else {
            // Otherwise show error.
            return <Alert severity="error">{t("errorBody_forbidden")}</Alert>;
        }
    }

    return (
        <Box sx={{display: "flex", justifyContent: "center", mt: 6}}>
            <CircularProgress />
        </Box>
    );
}

export default RequireAuth;
